import React, { Component } from "react";
import SwipeableViews from "react-swipeable-views";
import CardActions from "@material-ui/core/CardActions";
import QuestionNode from "./QuestionNode";
import DecisionNode from "./DecisionNode";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import FirstPage from "@material-ui/icons/FirstPage";
import Close from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DecisionTreeBreadrcrumbs from "./DecisionTreeBreadrcrumbs";

class DisplayDecisionTree extends Component {
  render() {
    return (
      <div>
        <CardHeader
          title={this.props.title}
          avatar={
            <div>
              <IconButton aria-label="Restart decision tree">
                <FirstPage onClick={this.backToStart} />
              </IconButton>
              <IconButton aria-label="Back a question">
                <ChevronLeft onClick={this.backAQuestion} />
              </IconButton>
            </div>
          }
          action={
            <>
              {this.props.editable && (
                <IconButton onClick={this.props.openEdit}>
                  <EditIcon />
                </IconButton>
              )}
              {!this.props.isSection && (
                <IconButton onClick={() => this.props.changeDisplayTree(0)}>
                  <Close />
                </IconButton>
              )}
            </>
          }
        />
        <DecisionTreeBreadrcrumbs
          backToQuestion={this.backToQuestion}
          questions={this.state.history}
          // answers={this.state.answers}
        />
        <SwipeableViews
          index={this.state.selected}
          id="pages"
          style={{ paddingTop: "16px" }}
        >
          {this.state.history.map(
            (node, idx) =>
              node.type === "question" ? (
                <QuestionNode
                  changeQuestion={this.changeQuestion}
                  key={idx + "question"}
                  node={node}
                />
              ) : (
                <DecisionNode key={idx + "decision"} node={node} />
              )
          )}
        </SwipeableViews>
        {/* <CardActions> */}
        {/* <Button disabled={this.state.history[this.state.history.length - 1].type === "question" ? false : true}>Done</Button> */}
        {/* </CardActions> */}
        {/* <Snackbar
          severity="warning"
          open={this.state.incomplete}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={() => this.setState({ incomplete: false })}
          id="hotTopicSnack"
          message={"One of your decisions trees is incomplete (requires answers to every question and conclusion to every final answer)."}
        /> */}
      </div>
    );
  }
  // checkIfComplete = (node) => {
  //   if ((!node.children || node.children.length === 0) && node.type !== "decision") {
  //     this.setState({ incomplete: true });
  //   } else if (node.children && node.children.length > 0) {
  //     node.children.map((child) => this.checkIfComplete(child));
  //   }
  // }
  componentDidMount = () => {
    console.log(this.props);
    this.setState({ history: [this.props.node.children[0]] });
    // this.setState({ incomplete: false });
    // let incomplete = false;
    this.setState({ incomplete: false });
    this.checkIfComplete(this.props.node);
    this.props.onRenderComplete && this.props.onRenderComplete(this.props.sectionId);
  };
  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.node) !== JSON.stringify(this.props.node)) {
      this.setState({ history: [this.props.node.children[0]] });
      this.setState({ incomplete: false });
      this.checkIfComplete(this.props.node);
    }
    if (prevState.incomplete != this.state.incomplete) {
      if (this.props.setIncomplete) {
        this.props.setIncomplete(this.state.incomplete);
      }
    }
  }
  checkIfComplete = (node) => {
    if (
      (!node.children || node.children.length === 0) &&
      node.type !== "decision"
    ) {
      this.setState({ incomplete: true });
    } else if (node.children && node.children.length > 0) {
      node.children.map((child) => {
        this.checkIfComplete(child);
      });
    }
  };
  backToQuestion = (question) => {
    for (let i = 0; i < this.state.history.length; i++) {
      if (this.state.history[i].number === question.number) {
        let tempHistory = this.state.history.splice(0);
        let tempAnswers = this.state.answers.splice(0);
        if (tempAnswers.length === tempHistory.length) {
          tempAnswers.splice(i, tempAnswers.length - (i + 1));
        } else {
          tempAnswers.splice(i, tempAnswers.length - i);
        }
        tempHistory.splice(i + 1, tempHistory.length - (i + 1));
        this.setState({
          history: tempHistory,
          selected: i,
          answers: tempAnswers,
        });
        return;
      }
    }
  };
  backAQuestion = () => {
    if (this.state.history.length > 1) {
      // let tempAnswers = this.state.answers.splice(0);
      let tempHistory = this.state.history.splice(0);
      // if (tempAnswers.length === tempHistory.length) {
      //   tempAnswers.pop();
      // }
      tempHistory.pop();
      tempHistory.pop();
      this.setState({
        history: tempHistory,
        selected: this.state.selected - 2,
        // answers: tempAnswers,
      });
    }
  };
  backToStart = () => {
    if (this.state.history.length > 1) {
      let tempHistory = this.state.history.splice(0);
      tempHistory.splice(1, tempHistory.length - 1);
      // this.setState({ history: tempHistory, selected: 0, answers: [] });
      this.setState({ history: tempHistory, selected: 0 });
    }
  };
  changeQuestion = (answer, question) => {
    if (question) {
      let tempHistory = this.state.history.splice(0);
      tempHistory.push(answer);
      tempHistory.push(question);
      this.setState(
        {
          history: tempHistory,
          selected: this.state.selected + 2,
          // answers: tempAnswers,
        },
        () => {
          let docContainer = document.getElementById("internalScrollContainer");
          if (docContainer) {
            docContainer.scrollTo(0, 0);
          } else {
            let revContainer = document.getElementById(
              "revision-view-container"
            );
            if (revContainer && revContainer.parentNode) {
              revContainer.parentNode.scrollTo(0, 0);
            }
          }
        }
      );
    }
    // if (question) {
    //   let tempHistory = this.state.history.splice(0);
    //   tempHistory.push(question);
    //   let tempAnswers = [...this.state.answers];
    //   tempAnswers.push(answer);
    //   this.setState({
    //     history: tempHistory,
    //     selected: this.state.selected + 1,
    //     answers: tempAnswers,
    //   });
    // }
  };
  state = {
    history: [],
    answers: [],
    selected: 0,
  };
}
export default DisplayDecisionTree;
